/**
 * Regex to validate a strict 10-digit tn format.
 *
 * @module
 *
 */
const tnStrictRegex = /^[2-9]\d{2}[2-9]\d{2}\d{4}$/;

export { tnStrictRegex };
